export default __webpack_public_path__ + "static/media/logo.feff26ff.svg";